// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Erua","footer":"ModalFilter_footer__2r2Cf"};